const authConfig = {
  auth: {
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_APP_TENANT_ID}`,
    clientId: process.env.REACT_APP_AZURE_AD_APP_CLIENT_ID,
    redirectUri: `${window.location.origin}/callback`,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  scopes: ['user.Read', 'User.Read.All', 'Group.Read.All', 'People.Read.All', 'email'],
};

const redirectUrlCookieName = 'medicalServicesPortalReturnURL';

const authentication = {
  authConfig,
  redirectUrlCookieName,
};

export default authentication;
